module.exports = __webpack_public_path__ + "static/media/matilde-hat-china-normal.9c2d7863.png";